import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';
import { TChangePasswordApi } from '@onesource/schemas';
import axios from '../axios';
import { getAuthProviderHeader } from './auth-provider-utils';

export const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: async (payload: TChangePasswordApi) => {
      const { data } = await axios.post('/auth/change-password', payload, {
        headers: getAuthProviderHeader(),
      });
      return data;
    },
    onSuccess: () => {
      enqueueSnackbar('Password changed successfully!', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
    onError: (error: Error) => {
      const message =
        error instanceof AxiosError && error.response?.data?.message
          ? error.response.data.message
          : 'Failed to change password. Please check your current password and try again.';
      enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
  });
};
